/**
 * Popup do clique na chuva por satélite: a taxa estimada no ponto (a mesma
 * que pinta a cor ali), a intensidade em palavras e a hora a que ela se
 * refere. Produto e fonte ficam no painel e nos créditos.
 */
import { formatTimeBrt } from '../lib/time';
import { formatarValor } from '../previsao/camadas';
import { ProximosDiasAqui } from '../previsao/ProximosDiasAqui';
import type { QuadroGsmap } from './api';
import { PALETA_GSMAP } from './camada';

/** Intensidade da chuva em palavras (faixas usuais em mm/h). */
export function intensidade(v: number): string {
  if (v >= 50) return 'muito forte';
  if (v >= 10) return 'forte';
  if (v >= 2.5) return 'moderada';
  return 'fraca';
}

export function GsmapPopup(props: { v: number; q: QuadroGsmap; lonLat: [number, number] }) {
  const { v, q } = props;
  return (
    <div>
      <div className="font-semibold text-white tabular-nums">{`Chuva estimada: ${formatarValor(PALETA_GSMAP, v)} mm/h (${intensidade(v)})`}</div>
      <div className="text-[11px] text-ink-300 tabular-nums">
        Média de {formatTimeBrt(q.ini)} a {formatTimeBrt(q.fim)} · satélite (GSMaP)
      </div>
      <ProximosDiasAqui lon={props.lonLat[0]} lat={props.lonLat[1]} />
    </div>
  );
}
